import { useMemo } from "react"
import { compact } from "lodash";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import ActivateNewCycleButton from "../ActivateNewCycleButton";
import CycleActivityCard from "../CycleActivityCard";
import Card from "modules/Core/sub-modules/ui-kit/components/Card";
import styles from "./styles.module.scss";

export const Placeholder = ({ boothId, fetch }) => (
    <Card className={styles.initCard} borderless>
        <ActivateNewCycleButton callback={() => fetch({ boothId })} />
    </Card>
)

export default ({ cycle, boothId, refetch }) => {
    const flow = useMemo(() => compact(cycle?.flow), [cycle]);
    const isCompleted = Boolean(cycle?.stamps?.completed);
    return (
        <Container className={styles.container}>
            {flow.map((activity, index) => (
                <CycleActivityCard
                    key={activity.id}
                    boothId={boothId}
                    cycleId={cycle?.id}
                    activity={activity}
                    index={index}
                    flowLength={flow.length}
                    onRefetch={refetch}
                />
            ))}
        </Container>
    )
};
